<template>
  <v-dialog
    v-model="open"
    v-bind="$attrs"
    scroll-strategy="none"
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" :props="props" />
    </template>
    <v-card v-if="open" elevation="10">
      <v-overlay
        :model-value="loading"
        contained
        persistent
        class="loading-container"
      >
        <v-progress-circular indeterminate />
      </v-overlay>
      <v-card-title v-if="noToolbarTitle" class="card-title-no-toolbar">
        <slot name="title" />
        <v-btn v-if="!hideClose" icon @click="close">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-toolbar :color="toolbarTitleColor" max-height="64" v-else>
        <v-toolbar-title>
          <slot name="title" />
        </v-toolbar-title>
        <v-btn v-if="!hideClose" icon @click="close">
          <v-icon large>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="overflow: auto">
        <slot name="content" />
      </v-card-text>
      <v-card-actions v-if="!!$slots['actions']">
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { toRefs } from "vue";

const emit = defineEmits(["update:modelValue", "close"]);
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  interruptClose: {
    type: Boolean,
    default: false,
  },
  hideClose: {
    type: Boolean,
    default: false,
  },
  noToolbarTitle: {
    type: Boolean,
    default: false,
  },
  toolbarTitleColor: {
    type: String,
    default: "surface-secondary",
  },
});
const { loading, interruptClose, hideClose } = toRefs(props);

const open = defineModel();

function close() {
  emit("close");
  if (!interruptClose.value) {
    open.value = false;
  }
}

</script>
<style scoped>
.loading-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  max-width: 600px;
  width: 100%;
}
.card-title-no-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
